import React, { useEffect } from 'react';
//Context
import { useFallas } from './FallasContext';
//Material-UI
import {
    Modal,
    TextField,
    Button,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
//Icons
import { CirclePlus, X } from 'tabler-icons-react';

export default function NuevaFalla() {
    const {
        areas,
        catego,
        textF,
        setTextF,
        openM,
        createFalla,
        handleOpenM,
        handleCloseM,
        selectedCatego,
        setSelectedCatego,
        selectedArea,
        setSelectedArea,
        getAreasAndFallas,
        updateGridF,
        setUpdateGridF,
    } = useFallas();

    useEffect(() => {
        if (updateGridF === true) {
            getAreasAndFallas();
            setUpdateGridF(false);
        }
    }, [getAreasAndFallas, setUpdateGridF, updateGridF]);

    const canSubmit =
        textF.trim().length > 0 && selectedArea !== '' && selectedCatego !== '';

    return (
        <>
            <Button
                className="fallas-btn-add"
                variant="text"
                color="default"
                onClick={handleOpenM}
            >
                <span className="fallas-btn-content">
                    <CirclePlus size={16} strokeWidth={2} />
                    Agregar
                </span>
            </Button>

            <Modal open={openM} onClose={handleCloseM}>
                <div className="fallas-modal">
                    <div className="fallas-modal-header">
                        <h2 className="fallas-modal-title">Nueva falla</h2>
                        <IconButton size="small" onClick={handleCloseM}>
                            <X size={18} strokeWidth={2} />
                        </IconButton>
                    </div>

                    <div className="fallas-modal-body">
                        <TextField
                            label="Nombre"
                            value={textF}
                            onChange={(e) => setTextF(e.target.value)}
                            fullWidth
                        />

                        <FormControl fullWidth>
                            <InputLabel id="lbl-area">Área</InputLabel>
                            <Select
                                labelId="lbl-area"
                                value={selectedArea}
                                onChange={(e) => setSelectedArea(e.target.value)}
                            >
                                {areas.map((item) => (
                                    <MenuItem key={item.area1} value={item.area1.toString()}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="lbl-catego">Categoría</InputLabel>
                            <Select
                                labelId="lbl-catego"
                                value={selectedCatego}
                                onChange={(e) => setSelectedCatego(e.target.value)}
                            >
                                {catego.map((item) => (
                                    <MenuItem key={item.categoria} value={item.categoria.toString()}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="fallas-modal-footer">
                        <Button
                            className="fallas-modal-cancel"
                            variant="outlined"
                            onClick={handleCloseM}
                        >
                            Cancelar
                        </Button>
                        <Button
                            className="fallas-modal-submit"
                            variant="contained"
                            color="primary"
                            onClick={createFalla}
                            disabled={!canSubmit}
                        >
                            Crear falla
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
